import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { useOrganization } from '@components/OrganizationBoundary';
import isTrialEnd from '@helpers/isTrialEnd';
import { toggleBillingModal } from '@redux/actions/modalAction';
import { ContributorsLimitErrorNotificationIcon, CrossIcon } from '@icons';

function ExtraUsersAlert({ fullScreen = false }: { fullScreen?: boolean }) {
  const dispatch = useDispatch();
  const { currentOrganization } = useOrganization();
  const [isAlertVisible, setIsAlertVisible] = useState<boolean>(false);

  useEffect(() => {
    if (!currentOrganization.entity) return;
    const result = isTrialEnd(currentOrganization.entity);
    if (result) return;
    if (
      !currentOrganization.entity.lockReasons.includes('members-limit-exceeded')
    )
      return;

    setIsAlertVisible(true);
  }, [currentOrganization]);

  if (!isAlertVisible) return null;

  return (
    <div
      className={classNames(
        'alert-container',
        fullScreen && 'alert-container-full-screen'
      )}
    >
      <div className="info">
        <div className="icon">
          <ContributorsLimitErrorNotificationIcon />
        </div>
        <div className="copies">
          <span className="title">You&apos;ve exceeded your seat count</span>
          <span className="description">
            Your plan includes {currentOrganization.entity?.limitsV2.users} team
            members max. Upgrade your plan or remove users to continue
            collaborating.
          </span>
        </div>
      </div>
      <div className="actions">
        <Button
          type="primary"
          onClick={() => dispatch(toggleBillingModal({ visible: true }))}
        >
          Update account
        </Button>
        <CrossIcon
          style={{ cursor: 'pointer' }}
          onClick={() => setIsAlertVisible(false)}
        />
      </div>
    </div>
  );
}

export default ExtraUsersAlert;
